/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceSessionSummary
 */
export interface DeviceSessionSummary {
    /**
     * The device identity (e.g., CM001)
     * @type {string}
     * @memberof DeviceSessionSummary
     */
    deviceIdentity?: string;
    /**
     * The device friendly name
     * @type {string}
     * @memberof DeviceSessionSummary
     */
    friendlyName?: string;
    /**
     * Total number of charging sessions
     * @type {number}
     * @memberof DeviceSessionSummary
     */
    sessionCount?: number;
    /**
     * Total energy delivered in Wh
     * @type {number}
     * @memberof DeviceSessionSummary
     */
    energyWh?: number;
    /**
     * Charging success rate as a percentage (0-100)
     * @type {number}
     * @memberof DeviceSessionSummary
     */
    chargingSuccessRate?: number;
    /**
     * The device group tag for the parent site
     * @type {string}
     * @memberof DeviceSessionSummary
     */
    siteGroupTag?: string;
    /**
     * The parent site name
     * @type {string}
     * @memberof DeviceSessionSummary
     */
    siteName?: string;
    /**
     * The device group tag for the parent organisation
     * @type {string}
     * @memberof DeviceSessionSummary
     */
    orgGroupTag?: string;
    /**
     * The parent organisation name
     * @type {string}
     * @memberof DeviceSessionSummary
     */
    orgName?: string;
    /**
     * Service model device group tag
     * @type {string}
     * @memberof DeviceSessionSummary
     */
    serviceModelGroupTag?: string;
    /**
     * Service model name
     * @type {string}
     * @memberof DeviceSessionSummary
     */
    serviceModelName?: string;
    /**
     * Device model (hardware model identifier)
     * @type {string}
     * @memberof DeviceSessionSummary
     */
    deviceModel?: string;
    /**
     * List of all device group tags this device belongs to
     * @type {Array<string>}
     * @memberof DeviceSessionSummary
     */
    deviceGroupTags?: Array<string>;
}

/**
 * Check if a given object implements the DeviceSessionSummary interface.
 */
export function instanceOfDeviceSessionSummary(
    value: object,
): value is DeviceSessionSummary {
    return true;
}

export function DeviceSessionSummaryFromJSON(json: any): DeviceSessionSummary {
    return DeviceSessionSummaryFromJSONTyped(json, false);
}

export function DeviceSessionSummaryFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceSessionSummary {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        friendlyName:
            json["friendlyName"] == null ? undefined : json["friendlyName"],
        sessionCount:
            json["sessionCount"] == null ? undefined : json["sessionCount"],
        energyWh: json["energyWh"] == null ? undefined : json["energyWh"],
        chargingSuccessRate:
            json["chargingSuccessRate"] == null
                ? undefined
                : json["chargingSuccessRate"],
        siteGroupTag:
            json["siteGroupTag"] == null ? undefined : json["siteGroupTag"],
        siteName: json["siteName"] == null ? undefined : json["siteName"],
        orgGroupTag:
            json["orgGroupTag"] == null ? undefined : json["orgGroupTag"],
        orgName: json["orgName"] == null ? undefined : json["orgName"],
        serviceModelGroupTag:
            json["serviceModelGroupTag"] == null
                ? undefined
                : json["serviceModelGroupTag"],
        serviceModelName:
            json["serviceModelName"] == null
                ? undefined
                : json["serviceModelName"],
        deviceModel:
            json["deviceModel"] == null ? undefined : json["deviceModel"],
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
    };
}

export function DeviceSessionSummaryToJSON(
    value?: DeviceSessionSummary | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        friendlyName: value["friendlyName"],
        sessionCount: value["sessionCount"],
        energyWh: value["energyWh"],
        chargingSuccessRate: value["chargingSuccessRate"],
        siteGroupTag: value["siteGroupTag"],
        siteName: value["siteName"],
        orgGroupTag: value["orgGroupTag"],
        orgName: value["orgName"],
        serviceModelGroupTag: value["serviceModelGroupTag"],
        serviceModelName: value["serviceModelName"],
        deviceModel: value["deviceModel"],
        deviceGroupTags: value["deviceGroupTags"],
    };
}
